import icons from "./icons"

const svgIcons = Object.keys(icons).map(icon => ({ val: icon, label: icon }))
const htmlNodeGetText = node =>
    node.nodes
        ? node.nodes.reduce(
              (acc, node) =>
                  acc +
                  (node.object === "text"
                      ? node.leaves.reduce((acc, leaf) => acc + leaf.text, "")
                      : htmlNodeGetText(node)),

              ""
          )
        : ""
const htmlIsEmpty = value =>
    !value || !value.document || htmlNodeGetText(value.document).trim() === ""

const fieldTypes = {
    img: {
        arrowRenderers: [icons.ArrowLeft, icons.ArrowRight],
        isEmpty: value => !value || value.length === 0,
    },
    text: {
        name: "Text simplu",
        dynamic: false,
        isEmpty: value => !value || (typeof value === "string" && value.trim() === ""),
    },
    html: {
        name: "Text",
        isEmpty: htmlIsEmpty,
    },
    bool: { dynamic: false },
    class: { dynamic: false },
    radio: { dynamic: false },
    list: { dynamic: false },
    obj: { dynamic: false },
    custom: { dynamic: false },

    href: {
        name: "Legătură simplă",
        type: "text",
        isEmpty: value => !value || value === "",
        _nowrap: true,
        renderer: "Link",
    },
    intro: {
        name: "Intro",
        type: "obj",
        isBlock: true,
        _nowrap: true,
        renderer: "Intro",
        dynamic: false,
        fields: [{ name: "sections", type: "list", label: "Sectiuni", items: "introSection" }],
    },
    introSection: {
        name: "Sectiune",
        type: "obj",
        _nowrap: true,
        fields: [
            { name: "text", type: "html", label: "Text" },
            { name: "img", type: "img", label: "Imagine" },
        ],
        dynamic: false,
        renderer: "IntroSection",
    },
    link: {
        name: "Legătură",
        type: "obj",
        fields: [
            { name: "label", type: "text", label: "Etichetă" },
            { name: "path", type: "text", label: "Legătură" },
        ],
        isEmpty: value => !value || !value.path || value.path === "",
        _nowrap: true,
        renderer: "LinkRenderer",
    },

    block: {
        name: "Container",
        type: "obj",
        isBlock: true,
        _nowrap: true,
        fields: [],
        settings: [
            { name: "_o", type: "bool", label: "Orizontal", widget: "toggle" },
            { name: "bg", type: "img", label: "Imagine" },
            { name: "p", type: "bool", label: "Proporțional", widget: "toggle" },
            { name: "f", type: "bool", label: "Fullscreen fixed", widget: "toggle" },
        ],
        renderer: "Block",
    },
    icon: {
        name: "Icon",
        type: "obj",
        _nowrap: true,
        fields: [
            { name: "icon", type: "select", values: svgIcons, label: "Iconiță" },
            { name: "img", type: "img", label: "Icon", single: true },
            { name: "big", type: "bool", label: "Text mare", widget: "toggle" },
            { name: "text", type: "html", label: "Text" },
        ],
        renderer: "Icon",
    },
    quote: {
        name: "Citat",
        type: "obj",
        fields: [
            { name: "content", type: "html", label: "Citat" },
            { name: "source", type: "text", label: "Sursa", fullWidth: true },
        ],
        renderer: "Quote",
    },
    menuItem: {
        name: "Item",
        dynamic: false,
        type: "obj",
        fields: [
            { name: "title", type: "text", label: "Titlu" },
            { name: "p", type: "text", label: "Cale" },
            { name: "items", type: "list", items: "menuItem", label: "Submeniu" },
        ],
    },

    endowments: {
        name: "Dotari",
        type: "list",
        items: "endowmentsItem",
        renderer: "Endowments",
        _nowrap: true,
    },
    endowmentsItem: {
        name: "Item",
        type: "obj",
        dynamic: false,
        fields: [
            { name: "descr", type: "html", label: "Text" },
            { name: "img", type: "img", label: "Imagini" },
        ],
    },
}

export { fieldTypes }
